import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EquipmentClassService {
  equipmentClassTypeValidated: Subject<boolean> = new Subject<boolean>();

  constructor() {}
}
